import GenerateDataForm from "./GenerateDataForm";
export default GenerateDataForm;
